import React from "react";
import { Box, Card, Grid, Typography } from "@mui/material";

export default function ViewCarousel({ CarouselId, carouselName, storeId, filters, stores }) {
    // Get store name from storeId
    const storeName = storeId && stores?.stores?.length > 0
        ? stores.stores.find(store => store?.storeId === storeId)?.storeName || "-"
        : "-";

    // Get counts and data
    const brandsCount = filters?.brands?.length || 0;
    const categoriesCount = filters?.categories?.length || 0;
    const strainsCount = filters?.strains?.length || 0;
    const traitsCount = filters?.traits?.length || 0;
    const pageName = filters?.pageId?.length || 0;
    const minProducts = filters?.productLimit?.min || "-";
    const maxProducts = filters?.productLimit?.max || "-";

    return (
        <Box display="flex" flexDirection="column" gap={2} style={{ height: "100%" }}>
            <Card sx={{ borderRadius: 2.5, boxShadow: "none", p: 3 }} style={{ height: "100%" }}>
                <Typography variant="h6" fontWeight="bold" mb={2}>Applied Filters</Typography>
                <ul style={{ listStyle: "none", display: "flex", flexDirection: "column", gap: "18px" }}>
                    <li>
                        <Typography variant="body2" fontWeight="semibold" color="#2E2E3A">
                            Carousel Name
                        </Typography>
                        <Box display="flex" alignItems="center" gap={1} flexWrap="wrap">
                            <Typography
                                variant="body2"
                                fontWeight="medium"
                                color="#707070"
                                style={{
                                    background: "#f3f3f3",
                                    padding: "3px 12px",
                                    fontSize: "12px",
                                    minWidth: "auto",
                                    maxWidth: "max-content",
                                    borderRadius: "40px",
                                    textAlign: "center"
                                }}
                            >
                                {carouselName}
                            </Typography>
                        </Box>
                    </li>
                    {/* Brands */}
                    <li>
                        <Typography variant="body2" fontWeight="semibold" color="#2E2E3A" mb={0.5}>
                            Brands ({brandsCount})
                        </Typography>
                        <Box display="flex" alignItems="center" gap={1} flexWrap="wrap" style={{ maxHeight: "120px", overflow: "auto" }}>
                            {brandsCount > 0 ? (
                                filters.brands.map((brand, idx) => (
                                    <Typography
                                        key={idx}
                                        variant="body2"
                                        fontWeight="medium"
                                        color="#707070"
                                        style={{
                                            background: "#f3f3f3",
                                            padding: "3px 12px",
                                            fontSize: "12px",
                                            minWidth: "auto",
                                            maxWidth: "max-content",
                                            borderRadius: "40px",
                                            textAlign: "center"
                                        }}
                                    >
                                        {brand?.brandName || "-"}
                                    </Typography>
                                ))
                            ) : (
                                <Typography variant="body2" fontWeight="medium" color="#707070" style={{ padding: "5px 0" }}>
                                    -
                                </Typography>
                            )}
                        </Box>
                    </li>

                    {/* Categories */}
                    <li>
                        <Typography variant="body2" fontWeight="semibold" color="#2E2E3A" mb={0.5}>
                            Categories ({categoriesCount})
                        </Typography>
                        <Box display="flex" alignItems="center" gap={1} flexWrap="wrap" style={{ maxHeight: "120px", overflow: "auto" }}>
                            {categoriesCount > 0 ? (
                                filters.categories.map((category, idx) => (
                                    <Typography
                                        key={idx}
                                        variant="body2"
                                        fontWeight="medium"
                                        color="#707070"
                                        style={{
                                            background: "#f3f3f3",
                                            padding: "3px 12px",
                                            fontSize: "12px",
                                            minWidth: "auto",
                                            maxWidth: "max-content",
                                            borderRadius: "40px",
                                            textAlign: "center"
                                        }}
                                    >
                                        {category?.categoryName || "-"}
                                    </Typography>
                                ))
                            ) : (
                                <Typography variant="body2" fontWeight="medium" color="#707070" style={{ padding: "5px 0" }}>
                                    -
                                </Typography>
                            )}
                        </Box>
                    </li>

                    {/* Strain Types */}
                    <li>
                        <Typography variant="body2" fontWeight="semibold" color="#2E2E3A" mb={0.5}>
                            Strain Types ({strainsCount})
                        </Typography>
                        <Box display="flex" alignItems="center" gap={1} flexWrap="wrap">
                            {strainsCount > 0 ? (
                                filters.strains.map((strain, idx) => (
                                    <Typography
                                        key={idx}
                                        variant="body2"
                                        fontWeight="medium"
                                        color="#707070"
                                        style={{
                                            background: "#f3f3f3",
                                            padding: "3px 12px",
                                            fontSize: "12px",
                                            minWidth: "auto",
                                            maxWidth: "max-content",
                                            borderRadius: "40px",
                                            textAlign: "center"
                                        }}
                                    >
                                        {strain?.strainType || "-"}
                                    </Typography>
                                ))
                            ) : (
                                <Typography variant="body2" fontWeight="medium" color="#707070" style={{ padding: "5px 0" }}>
                                    -
                                </Typography>
                            )}
                        </Box>
                    </li>

                    {/* Product Traits */}
                    <li>
                        <Typography variant="body2" fontWeight="semibold" color="#2E2E3A" mb={0.5}>
                            Product Traits ({traitsCount})
                        </Typography>
                        <Box display="flex" alignItems="center" gap={1} flexWrap="wrap" style={{ maxHeight: "120px", overflow: "auto" }}>
                            {traitsCount > 0 ? (
                                filters.traits.map((trait, idx) => (
                                    <Typography
                                        key={idx}
                                        variant="body2"
                                        fontWeight="medium"
                                        color="#707070"
                                        style={{
                                            background: "#f3f3f3",
                                            padding: "3px 12px",
                                            fontSize: "12px",
                                            minWidth: "auto",
                                            maxWidth: "max-content",
                                            borderRadius: "40px",
                                            textAlign: "center"
                                        }}
                                    >
                                        {trait?.subTraitName || "-"}
                                    </Typography>
                                ))
                            ) : (
                                <Typography variant="body2" fontWeight="medium" color="#707070" style={{ padding: "5px 0" }}>
                                    -
                                </Typography>
                            )}
                        </Box>
                    </li>

                    {/* Store (only show if storeId exists) */}
                    {storeId ? (
                        <li>
                            <Typography variant="body2" fontWeight="semibold" color="#2E2E3A" mb={0.5}>
                                Store
                            </Typography>
                            <Box display="flex" alignItems="center" gap={1} flexWrap="wrap">
                                <Typography
                                    variant="body2"
                                    fontWeight="medium"
                                    color="#707070"
                                    style={{
                                        background: "#f3f3f3",
                                        padding: "3px 12px",
                                        fontSize: "12px",
                                        minWidth: "auto",
                                        maxWidth: "max-content",
                                        borderRadius: "40px",
                                        textAlign: "center"
                                    }}
                                >
                                    {storeName}
                                </Typography>
                            </Box>
                        </li>
                    ) : null}

                    {/* Page Name */}
                    <li>
                        <Typography variant="body2" fontWeight="semibold" color="#2E2E3A" mb={0.5}>
                            Page Name
                        </Typography>
                        <Box display="flex" alignItems="center" gap={1} flexWrap="wrap">
                            {
                                pageName > 0 ?
                                    filters.pageId.map((page, idx) => (
                                        <Typography
                                            key={idx}
                                            variant="body2"
                                            fontWeight="medium"
                                            color="#707070"
                                            style={{
                                                background: "#f3f3f3",
                                                padding: "3px 12px",
                                                fontSize: "12px",
                                                minWidth: "auto",
                                                maxWidth: "max-content",
                                                borderRadius: "40px",
                                                textAlign: "center"
                                            }}
                                        >
                                            {page || "-"}
                                        </Typography>
                                    ))
                                    :
                                    <Typography variant="body2" fontWeight="medium" color="#707070" style={{ padding: "5px 0" }}>
                                        -
                                    </Typography>

                            }

                        </Box>
                    </li>

                    {/* Product Quantity Limits */}
                    <li>
                        <Box display="flex" alignItems="center" gap={4}>
                            <Box>
                                <Typography variant="body2" fontWeight="semibold" color="#2E2E3A" mb={0.5}>
                                    Minimum Product Qty
                                </Typography>
                                <Box display="flex" alignItems="center" gap={1} flexWrap="wrap">
                                    <Typography variant="body2" fontWeight="medium" color="#707070" style={{ padding: "5px 0" }}>
                                        {minProducts}
                                    </Typography>
                                </Box>
                            </Box>
                            <Box>
                                <Typography variant="body2" fontWeight="semibold" color="#2E2E3A" mb={0.5}>
                                    Maximum Product Qty
                                </Typography>
                                <Box display="flex" alignItems="center" gap={1} flexWrap="wrap">
                                    <Typography variant="body2" fontWeight="medium" color="#707070" style={{ padding: "5px 0" }}>
                                        {maxProducts}
                                    </Typography>
                                </Box>
                            </Box>
                        </Box>
                    </li>
                </ul>
            </Card>
        </Box>
    );
}
